/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import AccountLoyalty from './account-loyalty';
import AccountLoyaltyView from './account-loyalty.view';

export * from './account-loyalty';
export * from './account-loyalty.data';
export { IAccountLoyaltyConfig, IAccountLoyaltyProps, IAccountLoyaltyResources } from './account-loyalty.props.autogenerated';
export * from './account-loyalty.view';
export * from './components';

export { AccountLoyalty, AccountLoyaltyView };
